import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { DepartmentSchema } from '../../entities/department/department.schema';
/**
 * A department whose manager is still unresolved (`manager` unset). This is
 * the ONLY contract exposing `managerEmail` — the general DepartmentSchema
 * stays clean (ADR 0012).
 */ export const UnresolvedDepartmentSchema = DepartmentSchema.pick({
    _id: true,
    name: true,
    description: true,
    abbreviation: true
}).extend({
    // Required here (optional on the entity): wizard rows always carry a path.
    path: z.string(),
    managerEmail: z.string().optional()
});
export const ListUnresolvedDepartmentsRequestSchema = z.object({});
export const ListUnresolvedDepartmentsResponseSchema = z.array(UnresolvedDepartmentSchema);
export const ListUnresolvedDepartmentsErrorSchema = BaseErrorSchema;

//# sourceMappingURL=list-unresolved-departments.schema.js.map